import { Input } from "@/components/ui/input";

export const RUBRIC = [["content", "Content"], ["structure", "Structure"], ["language", "Language"], ["conventions", "Conventions"]];
export const rubricTotal = (r) => RUBRIC.reduce((s, [k]) => s + (Number(r?.[k]) || 0), 0);

export function RubricInputs({ value, onChange, n }) {
  return (
    <div className="space-y-2" data-testid={`rubric-${n}`}>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        {RUBRIC.map(([k, l]) => (
          <label key={k} className="text-xs font-semibold text-[#524B6B]">{l} /10
            <Input type="number" min="0" max="10" value={value[k] ?? ""} data-testid={`rubric-${n}-${k}`}
              onChange={(e) => onChange({ ...value, [k]: e.target.value })} className="mt-1 h-9 rounded-xl" />
          </label>
        ))}
      </div>
      <textarea value={value.comment || ""} onChange={(e) => onChange({ ...value, comment: e.target.value })} data-testid={`rubric-${n}-comment`}
        placeholder="Feedback for the student (optional)" className="min-h-[70px] w-full rounded-xl border border-[#E9E5F5] p-2 text-sm outline-none focus:border-[#C4B5FD]" />
      <div className="text-right text-sm font-bold text-[#1E1B2E]">{rubricTotal(value)}/40</div>
    </div>
  );
}

export function RubricView({ r }) {
  return (
    <div className="mt-2 rounded-lg bg-[#FAF9FE] p-2.5" data-testid="rubric-view">
      <div className="grid grid-cols-2 gap-1 text-xs sm:grid-cols-4">
        {RUBRIC.map(([k, l]) => <span key={k} className="font-semibold text-[#524B6B]">{l}: <b className="text-[#1E1B2E]">{r[k] ?? 0}/10</b></span>)}
      </div>
      {r.comment && <p className="mt-2 whitespace-pre-wrap text-sm text-[#1E1B2E]">{r.comment}</p>}
    </div>
  );
}
